"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _X22FP4G7cjs = require('../__chunks/X22FP4G7.cjs');
require('../__chunks/PLY2V46G.cjs');


var _OTCKJ4OKcjs = require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/hovercard/hovercard-arrow.tsx
var TagName = "div";
var useHovercardArrow = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useHovercardArrow2({ store, ...props }) {
    const context = _OTCKJ4OKcjs.useHovercardContext.call(void 0, );
    store = store || context;
    props = _X22FP4G7cjs.usePopoverArrow.call(void 0, { store, ...props });
    return props;
  }
);
var HovercardArrow = _PTOCUU2Dcjs.forwardRef.call(void 0, function HovercardArrow2(props) {
  const htmlProps = useHovercardArrow(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.HovercardArrow = HovercardArrow; exports.useHovercardArrow = useHovercardArrow;
